import { SxProps, Theme } from '@mui/material';

const container: SxProps<Theme> = (theme) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  height: theme.spacing(8),
  paddingX: 2,
  marginLeft: 1,

  backgroundColor: theme.palette.primary.dark,
  borderColor: theme.palette.primary.dark,

  color: theme.palette.common.white,
  textAlign: 'center',

  '&:first-of-type': {
    marginLeft: 0,
  },
});

const styles = {
  container,
};

export default styles;
